import React from 'react';
import SEO from "../../common/SEO";
import HeaderOne from '../../common/header/HeaderOne';
import HeaderTopBar from '../../common/header/HeaderTopBar';
import FooterOne from '../../common/footer/FooterOne';
import Copyright from '../../common/footer/Copyright';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';

const PaymentSuccess = () => {
    return (
        <>
            <SEO title="Payment Success" />
            <main className="page-wrapper">
                <HeaderTopBar />
                <HeaderOne btnStyle="btn-small" HeaderSTyle="header-transparent" />

                <div className="rwt-advance-tab-area rn-section-gap">
                    <div className="container text-center">
                        <div className='w-75 mx-auto'>
                            <h2 className="text-3xl font-bold mb-4">🎉 Your order has been successfully completed!</h2>
                            <p className="mb-6 text-lg">Thank you for your purchase. We appreciate your trust in us!</p>
                            <Link to="/" className="btn-default">Go to Homepage</Link>
                        </div>
                    </div>
                </div>

                <FooterOne />
                <Copyright />
            </main>
        </>
    );
};

export default PaymentSuccess;
